import { useDimensions } from "@repo/core/hooks/useDimensions";
import { MenuActionItemProps } from "@repo/core/components/layout/MenuActionsList/components/MenuActionItem/types";
import { useNewTransactionFlow } from "@repo/core/hooks/useNewTransactionFlow";
import { ROUTES } from "@repo/core/routes";

export const NewTransactionCaptureOptionsController = () => {
  // Hooks
  const { navigateToNext, currentRouteConfig, customNavigate, navigateBack } =
    useNewTransactionFlow();

  const { isMobile } = useDimensions();

  // Menu Actions
  const menuActionItems: MenuActionItemProps[] = [
    {
      leftIcon: "qrcode",
      title: "QR Code",
      onPress: () =>
        customNavigate({
          previous: ROUTES.newTransactionCaptureOptions,
          to: ROUTES.newTransactionQRCode,
          next: ROUTES.newTransactionValue
        })
    },
    {
      leftIcon: "pen",
      title: "Digitar dados da compra",
      onPress: () => navigateToNext()
    }
  ];

  return {
    isMobile,
    menuActionItems,
    title: currentRouteConfig.title,
    showConfirmStoreModal: currentRouteConfig.showConfirmStoreModal,
    navigateBack
  };
};
